/* eslint-disable import/no-named-as-default-member */
/* eslint-disable import/no-named-as-default */
import ReactDOM from 'react-dom';
import React from 'react';
import { unregister as unregisterServiceWorker } from 'Utils/pwa';
import initStore from 'App/initStore';
import App from 'App/app.jsx';
import { checkAndSetEndpointFromUrl, handleOAuthCallback, isOAuthCallback } from '@deriv/shared';
import AppNotificationMessages from './App/Containers/app-notification-messages.jsx';

// Analytics / observability SDKs (Sentry, Vercel Analytics, Vercel Speed Insights) removed
// 2026-05-05 — they were firing requests on every page load + buffering in third-party
// caches. Vercel Speed Insights specifically was 404ing /vercel/speed-insights/script.js
// (only available on Vercel hosting; we run on Cloudflare Pages). Sentry replays were
// hitting their own rate limits (HTTP 429). Re-add behind a feature flag if/when needed.

// Polyfills (babel-polyfill, promise-polyfill) removed 2026-05-05 — IE-era. All target
// browsers (Chrome/Firefox/Safari/Edge 2018+) ship native Promise + ES2017+. ~50–100 KB
// gzipped saved.

// Service worker — Cloudflare Pages already caches at the edge with proper cache-busting
// on each deploy (immutable filenames + index.html with no-cache). The app-level SW added
// no caching benefit and caused stale-bundle problems (had to be manually unregistered
// during dev several times). Unregister any SW that was registered by previous builds to
// clear out stale caches; don't register a new one.
if ('serviceWorker' in navigator) {
    unregisterServiceWorker();
}

// if we don't clear the local storage, then exchange_rates subscription calls won't be made when user refreshes the page
// check packages/stores/src/providers/ExchangeRatesProvider.tsx

if (window.localStorage.getItem('exchange_rates')) {
    window.localStorage.removeItem('exchange_rates');
}
// OAuth 2.0 + PKCE callback: exchange auth code for token, bridge into the legacy
// ?acct1=&token1=... URL shape that the existing client-store consumes. The handler
// always navigates away (success or error), so we skip React render in this branch.
if (isOAuthCallback()) {
    handleOAuthCallback();
} else {
    const has_endpoint_url = checkAndSetEndpointFromUrl();

    // if has endpoint url, APP will be redirected
    if (!has_endpoint_url) {
        const root_store = initStore(AppNotificationMessages);

        const wrapper = document.getElementById('deriv_app');
        if (wrapper) {
            ReactDOM.render(<App useSuspense={false} root_store={root_store} />, wrapper);
        }
    }
}
